import React from 'react';

// Import components
import Providers from 'components/hoc/Providers';
import Loader from 'components/elements/molecules/Loader';

const App = React.lazy(() => import('components/views/App'));

const Root = () => (
	<Providers>
		<React.Suspense fallback={<Loader />}>
			<App />
		</React.Suspense>
	</Providers>
);

export default Root;
